<ua-error *ngIf="error" [errorCode]="error"></ua-error>
<div *ngIf="configuration && !error" class="mt-4" >
  <form class="mt-3" [formGroup]="bookingForm">
    <div class="row">
      <h1 class="text-primary text-primary text-center">Book a Birthday Party!</h1>
      <ua-wizard-stepper [currentStep]=1 (stepChange)="stepChange($event)" [disabledSelect]="true"></ua-wizard-stepper>
    </div>
      
    <div id="divPackages" class="mt-3">
      <ua-skeleton-card *ngIf="!packages.length && !packagesLoaded" [count]="4"></ua-skeleton-card>
      <div *ngIf="!packages.length && packagesLoaded" class="text-center">
        <h3>Sorry, no packages available for the selected date</h3>
      </div>

      <div *ngFor="let partyPackage of packages; let i = index;">
        <div class="card mt-3 shadow border-2 rounded-5" [style.border-color]="partyPackage.productLevelColor">
          <div class="card-body d-flex" (click)="toggleSelection(i)">
            <div class="d-flex flex-column w-100 me-3">
              <div class="h2 fw-bold" [style.color]="partyPackage.productLevelColor"> {{ partyPackage.productLevelName }}
                <sup *ngIf="partyPackage.hasAttractions">
                  <button (click)="$event.stopPropagation(); showModal(partyPackage)" class="btn btn-link btn-sm p-0" style="z-index: 1">
                    <fa-icon [icon]="faInfoCircle"></fa-icon>
                  </button>
                </sup>
              </div>
              <p>{{partyPackage.productLevelDescription}}</p>
            </div>
            <ua-card-pricing class="ms-auto"
                             [price]="partyPackage.minCombinedPrice"
                             [quantity]="partyPackage.quantity"
                             [selected]="partyPackage.selected"
                             (selectClicked)="toggleSelection(i)">
            </ua-card-pricing>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4 g-3">
      <div class="col">
        Handicap accommodations?
      </div>
      <div class="col-4 mb-3">
        <div class="form-check mt-2">
          <input type="checkbox" class="form-check-input form-check-input-lg" formControlName="requiresHandicap">
        </div>
      </div>
    </div>

    <div id="divTimeslots" *ngIf="packageSelected" class="mt-4">
      <div *ngIf="booking" class="mt-4" id="divChooseATime">
        <ua-call-to-action class="text-center"
                           template="Choose a time"
                           [booking]="booking"
                           [possessive]="true">

        </ua-call-to-action>
      </div>
      <div class="row mt-2 mb-2 text-center">
        <div class="col-3"></div>
        <div class="col-6 mb-3">
          <label for="preferredDate">Preferred Party Date <span class="required-asterisk">*</span></label>
          <div class="input-group">
            <input id="preferredDate" class="form-control" angular-mydatepicker
                   formControlName="preferredDate" [options]="preferredDateOptions"
                   #preferredDate="angular-mydatepicker" placeholder="Select a date"/>
            <button type="button" class="btn btn-primary" (click)="preferredDate.toggleCalendar()">
              <fa-icon [icon]="faCalendarAlt"></fa-icon>
            </button>
          </div>
          <ua-display-validation-errors name='Preferred Date' [control]="bookingForm.controls.preferredDate"
                                        [force]="formDirty"></ua-display-validation-errors>
        </div>
      </div>
      <ua-timeslots-date (dateChanged)="updateDate($event)" (minPrice)="updateMinPrice($event)"></ua-timeslots-date>
      <p class="fst-italic disclaimer text-center" *ngIf="slotsLoaded && timeslots.length">
        *Prices may vary by time. Scroll to see more.
      </p>

      <div *ngIf="(!timeslots.length && slotsLoaded) || !booking || !booking.preferredTimeId || !booking.productLevelId" class="text-center mt-3">
        <h3>Sorry, no times available for the selected date</h3>
      </div>

      <ua-skeleton-card *ngIf="!slotsLoaded && booking && booking.preferredTimeId && booking.productLevelId" [count]="3"></ua-skeleton-card>
      <div *ngFor="let slot of timeslots; let i=index">
        <div class="card mt-3 shadow {{slot.partyThemeColorCode ? '' : 'border-primary'}} border-2 rounded-5" [ngStyle]="{'border-color':slot.partyThemeColorCode}">
          <div class="card-body d-flex" (click)="toggleTimeslotSelection(i)">
            <div class="d-flex flex-column w-100 me-3">
              <h5>{{slot.startTime | time | date:'shortTime'}} - {{slot.endTime | time | date:'shortTime'}}</h5>
              <div *ngIf="slot.partyThemeId === this.hangoutsGrouped[slot.startTime]?.partyThemeId"
                   class="{{slot.partyThemeColorCode ? '' : 'text-primary'}}">
                <strong>{{this.hangoutsGrouped[slot.startTime]?.name}}</strong>
                <sup *ngIf="this.hangoutsGrouped[slot.startTime]?.amenities?.length">
                  <button class="btn btn-link btn-sm p-0"
                          style="z-index: 1"
                          (click)="$event.stopPropagation(); showAmenitiesModalTimeslots(this.hangoutsGrouped[slot.startTime])">
                    <fa-icon [icon]="faInfoCircle"></fa-icon>
                  </button>
                </sup>
              </div>
              <div *ngIf="slot.partyThemeId !== 1" class="fw-bold {{slot.partyThemeColorCode ? '' : 'text-primary'}}"
                   [ngStyle]="{'color':slot.partyThemeColorCode}">{{ slot.partyTheme }}</div>
              <div class="d-flex justify-content-between mt-auto">
                <small *ngIf="slot.available <= 3" class="align-self-end {{slot.partyThemeColorCode ? '' : 'text-primary'}} mb-1"
                       [ngStyle]="{'color':slot.partyThemeColorCode}">
                  <strong>Only {{slot.available}} part{{slot.available > 1 ? 'ies' : 'y'}} left!</strong>
                </small>
              </div>
            </div>
            <ua-card-pricing id="card-{{i}}"
                             class="ms-auto"
                             [price]="slot.displayPrice"
                             [quantity]="slot.quantity"
                             [selected]="slot.selected"
                             (selectClicked)="toggleTimeslotSelection(i)"
                             [showSign]="true"
                             [style]="'showGuests'"
                             [imageUrl]="slot.partyThemeImageUrl">
            </ua-card-pricing>
          </div>
        </div>
      </div>
    </div>

    <div id="divHangouts" class="mt-4" *ngIf="timeslotSelected">
      <ua-call-to-action class="text-center" template="Choose a Hangout" [booking]="booking" [possessive]="true" [showTime]="true"></ua-call-to-action>
      <ua-skeleton-card *ngIf="!hangoutsLoaded" [count]="3" [descriptionHeight]="24" [priceHeight]="32"></ua-skeleton-card>
      <div *ngFor="let hangout of hangouts; let i = index;">
        <div class="card mt-3 shadow border-2 rounded-5"
             [ngClass]="hangout.available > 0 ? 'border-primary' : ''"
             (click)="toggleHangoutsSelection(i)"
        >
          <div *ngIf="hangout.available === 0" class="text-primary sold-out d-flex justify-content-center align-items-center">
            <div class="rp-15">SOLD OUT</div>
          </div>
          <div class="card-body d-flex" [ngClass]="hangout.available > 0 ? '' : 'opaque text-dark'">
            <div class="d-flex flex-column w-100 me-3">
              <h3 [ngClass]="hangout.available > 0 ? 'text-primary' : ''">
                {{hangout.name}}
                <sup *ngIf="hangout.amenities.length">
                  <button class="btn btn-link btn-sm p-0"
                          style="z-index: 1"
                          (click)="$event.stopPropagation(); showAmenitiesModalHangouts(hangout)">
                    <fa-icon [icon]="faInfoCircle"></fa-icon>
                  </button>
                </sup>
              </h3>

              <p>{{hangout.description}}</p>
            </div>
            <ua-card-pricing
                             id="hangout-{{i}}"
                             class="ms-auto"
                             [price]="hangout.displayPrice"
                             [selected]="hangout.selected"
                             [style]="'exact'"
                             (selectClicked)="toggleHangoutsSelection(i)"
                             [disabled]="hangout.available === 0"
                             [showSign]="true">
            </ua-card-pricing>
          </div>
        </div>
      </div>
    </div>

    <div id="divAtendees" class="mt-4" *ngIf="this.hangoutsSelectionChanged">
      <ua-call-to-action class="text-center" template="Attendees" [booking]="booking" [possessive]="true" [showTime]="true">
      </ua-call-to-action>

      <div class="px-4 mt-3">
        <div class="row">
          <div class="col-8 d-flex flex-column">
            <h6 class="fw-bold mb-0">
              Number of Kids who Will {{attendeesText}}:
            </h6>
            <ngx-skeleton-loader *ngIf="!attendeesLoaded" [theme]="{height: '18px'}"></ngx-skeleton-loader>
            <p class="fst-italic disclaimer"
               *ngIf="attendeesLoaded && attendeeRestrictions?.participantPrice !== undefined">
              *Add more kids for <ua-display-price [amount]="attendeeRestrictions?.participantPrice"></ua-display-price> per person.
            </p>
          </div>
          <div class="col-4">
            <ua-quantity [loaded]="attendeesLoaded" [count]="participantCount" [min]="attendeeRestrictions?.minQuantity"
                         [max]="attendeeRestrictions?.maxQuantity" [gtmTag]="'kid-participant-quantity'" (countDecreased)="subtractParticipant()"
                         (countIncreased)="addParticipant()">
            </ua-quantity>
          </div>
        </div>

        <div class="row" *ngIf="attendeeRestrictions && participantCount >= attendeeRestrictions.maxQuantity">
          <p class="fst-italic text-secondary disclaimer" >
            <!-- PMA or The Little Gym -->
            You have reached the capacity limitation of your {{this.brandId === 3 || this.brandId === 4
            ? 'party. Please call'
            : 'selected hangout. Please try a different hangout, or call'}} <a class="phone-link" [href]="'tel:' + phoneNumber">{{phoneNumber}}</a> {{this.brandId === 3  || this.brandId === 4
            ? 'for assistance in booking a larger party'
            : 'if you need further assistance'}}.
          </p>
        </div>
        <div class="row"
             *ngIf="attendeeRestrictions?.participantPrice && attendeeRestrictions?.adultParticipantPrice !== undefined">
          <div class="col-8 d-flex flex-column">
            <h6 class="fw-bold mb-0">
              Number of Parents who Will {{attendeesText}}:
            </h6>
            <ngx-skeleton-loader *ngIf="!attendeesLoaded" [theme]="{height: '18px'}"></ngx-skeleton-loader>
            <p class="fst-italic disclaimer"
               *ngIf="attendeesLoaded && attendeeRestrictions">
              *Parents are
              <ua-display-price *ngIf="attendeeRestrictions.adultParticipantPrice
              && attendeeRestrictions.adultParticipantPrice > 0; else noAdultPrice" [amount]="attendeeRestrictions.adultParticipantPrice">
              </ua-display-price>
              <ng-template #noAdultPrice>50% off</ng-template>
              to play. Parents can watch kids play for free.
            </p>
          </div>
          <div class="col-4">
            <ua-quantity [loaded]="attendeesLoaded" [count]="adultParticipantCount"
                         (countDecreased)="subtractAdultParticipant()" (countIncreased)="addAdultParticipant()"
                         [max]="adultParticipantPrice ? undefined : 0" [gtmTag]="'adult-participant-quantity'">
            </ua-quantity>
          </div>
        </div>
      </div>
    </div>

    <div id="divAddOns" *ngIf="booking && attendeesLoaded && !error" class="mt-4" #addOnsSection>

      <div class="text-center">
        <ua-call-to-action template="Additional items" [booking]="booking" [possessive]="true" [showTime]="true">
        </ua-call-to-action>
      </div>

      <ng-container *ngIf="resourceTypeModifiers">
        <ua-park-modifiers *ngIf="resourceTypeModifiers.length && addOnsLoaded"
                           [booking]="booking"
                           [modifiers]="resourceTypeModifiers"
                           [hasItemsToSelect]="hasItemsToSelect"
                           (bookingItems)="updateBookingItems($event)"
                           (formValid)="updateAddOnIsValid($event)"
                           [formDirty]="formDirty">
        </ua-park-modifiers>
      </ng-container>

      <h4 class="text-primary fw-bold mt-3">Additional Items:</h4>
      <ua-skeleton-card *ngIf="!addOnsLoaded"
                        [count]="3"
                        [descriptionHeight]="0"
                        [priceHeight]="32"
                        [hasImage]="true">
      </ua-skeleton-card>
      <ng-container *ngIf="addOnsLoaded">
        <div *ngFor="let product of products; let i = index">
          <div class="card mt-3 shadow border-primary border-2 rounded-5">
            <div class="card-body d-flex">
              <div>
                <div class="product-image">
                  <img src="{{product.imageUri}}" class="rounded img-fluid float-start" onerror="this.style.display='none'"/>
                </div>
              </div>
              <div class="w-100 mx-3">
                <h5>{{product.parkProductName}}</h5>
                <div>{{product.description}}</div>
              </div>
              <div class="d-flex flex-column justify-content-between align-items-center">
                <div class="text-huge">
                  +<ua-display-price [amount]="product.price"></ua-display-price>
                </div>
                <ua-quantity [loaded]="addOnsLoaded"
                             [count]="product.quantity"
                             [max]="product.maxQuantity"
                             (countDecreased)="removeAddOn(i)"
                             (countIncreased)="addAddOn(i)">
                </ua-quantity>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <div *ngIf="!products.length && addOnsLoaded" class="text-center mt-3">
        <h3>No additional items available</h3>
      </div>
    </div>

  </form>

  <div class="mt-5">
    <button type="button" class="btn btn-primary btn-lg w-100 fw-bold" (click)="goToReview()" [disabled]="disableNext || !addOnsLoaded || !isAddOnValid || !hangoutSelected">
      Review
    </button>
  </div>
</div>

<div class="modal fade" id="infoModal" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog">
    <div class="modal-content">
      <ua-package-info [booking]="booking"
                       [upgradeAttractions]="upgradeAttractions"
                       [availableAttractions]="availableAttractions"
                       [infoPackage]="infoPackage"
                       [upgradePackage]="upgradePackage"
                       [showAsUpgrade]="showAsUpgrade"
                       (dismissClicked)="closeModal()"
                       (upgradeClicked)="upgrade()">
      </ua-package-info>
    </div>
  </div>
</div>

<div id="amenitiesModalTimeSlots" class="modal" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body p-4">
        <h1 class="text-capitalize fs-1 fw-bold text-primary">Includes: </h1>
        <ul class="list-unstyled">
          <li *ngFor="let a of amenities"><h5><fa-icon class="text-primary me-2" [icon]="faCheck"></fa-icon>{{ a }}</h5></li>
        </ul>
      </div>
      <div class="align-self-center">
        <button type="button" class="btn btn-sm mt-2 mb-2 btn-primary" data-bs-dismiss="modal">Dismiss</button>
      </div>
    </div>
  </div>
</div>

<div id="amenitiesModalHangouts" class="modal" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body p-4">
        <h1 class="text-capitalize fs-1 fw-bold text-primary">Includes: </h1>
        <ul class="list-unstyled">
          <li *ngFor="let a of amenities"><h5><fa-icon class="text-primary me-2" [icon]="faCheck"></fa-icon>{{ a }}</h5></li>
        </ul>
      </div>
      <div class="align-self-center">
        <button type="button" class="btn btn-sm mt-2 mb-2 btn-primary" data-bs-dismiss="modal">Dismiss</button>
      </div>
    </div>
  </div>
</div>
